
import variables from './core/variables';
import appBar from './styles/appBar';
import button from './styles/button';
import card from './styles/card';
import cssBaseline from './styles/cssBaseline';
import dialog from './styles/dialog';
import divider from './styles/divider';
import icon from './styles/icon';
import iconButton from './styles/iconButton';
import input from './styles/input';
import list from './styles/list';
import tabs from './styles/tabs';
import tooltip from './styles/tooltip';
import touchRipple from './styles/touchRipple';
import typography from './styles/typography';


let overrides = {
  MuiBackdrop: {
    root: {
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto'
    }
  },
  MuiInputBase: {
    root: {
      minHeight: 30,
      backgroundColor: '#FFFFFF !important'
    },
    input: {
      display: 'flex !important'
    }
  },
  MuiInputLabel: {
    outlined: {
      transform: 'translate(5px, 5px) scale(1)'
    }
  },
  MuiSelect: {
    root: {
      minHeight: 35,
      minWidth: 60
    },
    select: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left'
    },
    selectMenu: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      minHeight: '2em !important'
    }
  },
  MuiOutlinedInput: {
    input: {
      padding: '0px 0px 0px 8px !important'
    }
  },
  MuiMenuItem: {
    root: {
      minHeight: 15
    }
  },
  MuiListItemSecondaryAction: {
    root: {
      top: 15
    }
  }
};

overrides = {
  ...overrides,
  MuiCssBaseline: cssBaseline,
  MuiButton: button,
  MuiCard: card,
  MuiAppBar: appBar,
  MuiDialog: dialog,
  MuiDivider: divider,
  MuiIcon: icon,
  MuiIconButton: iconButton,
  MuiInputBase: input,
  MuiList: list,
  MuiTabs: tabs,
  MuiTooltip: tooltip,
  MuiTouchRipple: touchRipple,
  MuiTypography: typography
};

export default {
  ...variables.theme,
  overrides
};
